import React, { useCallback, useContext, useEffect, useState } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { Box, CssBaseline, Toolbar, Container, Backdrop, useMediaQuery } from '@mui/material';
import Header from 'core/components/header';

import pgmTheme from './theme';
import Navbar from 'core/components/navbar';
import Loader from 'core/components/Loader';
import Copyright from 'components/CopyRight';
import { AppContext } from 'core/context';

const DefaultLayout = ({ children, navbar=true }) => {
  const [showBackdrop, setShowBackdrop] = useState(false);
  const { isSideDrawerOpen, updateAppContext } = useContext(AppContext);
  const matches = useMediaQuery('(max-width:1540px)');

  const handleClose = useCallback(() => {
    if(matches){
      updateAppContext({isSideDrawerOpen: false});
    }

  },[matches, updateAppContext]);

  useEffect(() => {
    if(matches){
      setShowBackdrop(isSideDrawerOpen)
    }else{
      setShowBackdrop(false)
    }
  }, [isSideDrawerOpen, matches])
  

  return (
    <ThemeProvider theme={pgmTheme}>
      <Box sx={{ display: 'flex' }}>
        <CssBaseline />
        <Loader />
        <Header hideNavIcon={!navbar}/>
        {navbar && <Navbar />}
        <Box
          component="main"
          sx={{
            backgroundColor: (theme) =>
              theme.palette.mode === 'light'
                ? theme.palette.grey[100]
                : theme.palette.grey[900],
            flexGrow: 1,
            maxHeight: 'calc(100vh - 51px)',
            overflow: 'auto',
            p: 2,
          }}
        >
          <Toolbar />
          <Container maxWidth="xl" >
            <Backdrop
              sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer - 1 }}
              open={showBackdrop}
              onClick={handleClose}
            >
            </Backdrop>
            {children}
            <Copyright sx={{ p: 2, backgroundColor: '#ffffff'}} />  
          </Container>
        </Box>
      </Box>
    </ThemeProvider>
  );
}
 
export default React.memo(DefaultLayout);
